"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isAllKongs_1 = require("./isAllKongs");
const isOrphans_1 = require("./isOrphans");
const isNineGates_1 = require("./isNineGates");
const isAllHonors_1 = require("./isAllHonors");
const isGreatDragon_1 = require("./isGreatDragon");
const isSmallWinds_1 = require("./isSmallWinds");
const isGreatWinds_1 = require("./isGreatWinds");
const isSmallDragon_1 = require("./isSmallDragon");
const isCommonHand_1 = require("./isCommonHand");
const isAllInTriplets_1 = require("./isAllInTriplets");
const isAllOneSuit_1 = require("./isAllOneSuit");
const isMixedOneSuit_1 = require("./isMixedOneSuit");
const isKaanKaanHand_1 = require("./isKaanKaanHand");
const isMixedOrphans_1 = require("./isMixedOrphans");
const isEightImmortalsCrossingTheSea_1 = require("./isEightImmortalsCrossingTheSea");
const isFlowerHand_1 = require("./isFlowerHand");
const isThirteenOrphans_1 = require("./isThirteenOrphans");
const isWinByDoubleKong_1 = require("./isWinByDoubleKong");
/**
 * This class includes static methods that help identify if a WinningHand belongs to any particular type of high-scoring hands.
 */
class HandTypeFinder {
}
exports.default = HandTypeFinder;
HandTypeFinder.isThirteenOrphansAsWinningHand = isThirteenOrphans_1.isThirteenOrphansAsWinningHand;
HandTypeFinder.isAllKongs = isAllKongs_1.default;
HandTypeFinder.isOrphans = isOrphans_1.default;
HandTypeFinder.isNineGates = isNineGates_1.default;
HandTypeFinder.isAllHonors = isAllHonors_1.default;
HandTypeFinder.isGreatDragon = isGreatDragon_1.default;
HandTypeFinder.isSmallWinds = isSmallWinds_1.default;
HandTypeFinder.isGreatWinds = isGreatWinds_1.default;
HandTypeFinder.isSmallDragon = isSmallDragon_1.default;
HandTypeFinder.isCommonHand = isCommonHand_1.default;
HandTypeFinder.isAllInTriplets = isAllInTriplets_1.default;
HandTypeFinder.isAllOneSuit = isAllOneSuit_1.default;
HandTypeFinder.isMixedOneSuit = isMixedOneSuit_1.default;
HandTypeFinder.isKaanKaanHand = isKaanKaanHand_1.default;
HandTypeFinder.isEightImmortalsCrossingTheSea = isEightImmortalsCrossingTheSea_1.default;
HandTypeFinder.isFlowerHand = isFlowerHand_1.default;
HandTypeFinder.isMixedOrphans = isMixedOrphans_1.default;
HandTypeFinder.isWinByDoubleKong = isWinByDoubleKong_1.default;
